"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require("react-redux");

var _CouponRedeem = require("./CouponRedeem");

var _CouponRedeem2 = _interopRequireDefault(_CouponRedeem);

var _styles = require("./styles.scss");

var _styles2 = _interopRequireDefault(_styles);

var _Preloader = require("@quixeltools/quixel-ui-library/dist/components/common/website/Preloader");

var _Preloader2 = _interopRequireDefault(_Preloader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CouponRedeemPopup = (_temp = _class = function (_React$Component) {
  (0, _inherits3.default)(CouponRedeemPopup, _React$Component);

  function CouponRedeemPopup(props) {
    (0, _classCallCheck3.default)(this, CouponRedeemPopup);

    var _this = (0, _possibleConstructorReturn3.default)(this, (CouponRedeemPopup.__proto__ || (0, _getPrototypeOf2.default)(CouponRedeemPopup)).call(this, props));

    _this.state = {
      coupon: null,
      type: null
    };
    _this.triggerPopup = _this.triggerPopup.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(CouponRedeemPopup, [{
    key: "triggerPopup",
    value: function triggerPopup(type) {
      var _props = this.props,
          coupon = _props.location.query.coupon,
          router = _props.router,
          isLoggedIn = _props.isLoggedIn,
          user = _props.user;

      this.setState({ coupon: coupon, type: type });
      if (!isLoggedIn && coupon) {
        router.push({
          pathname: "/login",
          query: { returnTo: "/?type=" + type + "&coupon=" + coupon },
          state: { modal: true }
        });
      }
      if (isLoggedIn && coupon) {
        this.context.dialogs.custom(_react2.default.createElement(_CouponRedeem2.default, { coupon: coupon, type: type, user: user }));
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.location.query.type && nextProps.location.query.type !== this.props.location.query.type) {
        this.triggerPopup(nextProps.location.query.type);
      }
      if (nextProps.isLoggedIn && this.props.isLoggedIn !== nextProps.isLoggedIn && this.state.coupon) {
        this.context.dialogs.custom(_react2.default.createElement(_CouponRedeem2.default, {
          coupon: this.state.coupon,
          type: this.state.type,
          user: this.props.user
        }));
        this.setState({ coupon: null });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _props$location$query = this.props.location.query,
          type = _props$location$query.type,
          coupon = _props$location$query.coupon;

      return !type && coupon ? _react2.default.createElement(
        "div",
        { className: _styles2.default.overlay },
        _react2.default.createElement(
          "div",
          { className: _styles2.default.preloader },
          _react2.default.createElement(_Preloader2.default, null)
        )
      ) : null;
    }
  }]);
  return CouponRedeemPopup;
}(_react2.default.Component), _class.contextTypes = {
  router: _react2.default.PropTypes.object,
  dialogs: _react2.default.PropTypes.object
}, _temp);
exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    isLoggedIn: state.auth.loggedIn,
    user: state.user
  };
})(CouponRedeemPopup);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/CouponRedeem/CouponRedeemPopup.jsx
// module id = 2873
// module chunks = 0